// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ql-toolbar {
  border-top-left-radius: 0.5rem !important;
  border-top-right-radius: 0.5rem !important;
}

.ql-container {
  border-bottom-left-radius: 0.5rem !important;
  display: flex !important;
  flex-direction: column !important;
  border-bottom-right-radius: 0.5rem !important;
}
  
.ql-blank, .ql-editor{
  min-height: 8rem !important;
  max-height: 30rem !important;
  font-size: 14px !important; /* Default font size */
  max-width: 100% !important;
  white-space: normal !important;
}

.ql-editor span {
  margin-left: 0 !important; /* Removes the unwanted left margin */
  padding-left: 0 !important; /* Remove any padding that may be added */
  font-size: inherit !important; /* Ensure font size remains consistent */
}

.react-quill {
  height: 150px !important; /* Adjust height of the Quill editor */
  padding: 10px !important;
  box-sizing: border-box !important; /* Ensure padding doesn't affect width */
}

.ql-toolbar.ql-snow{
  width: 100% !important;
}

.ql-container.ql-snow {
  width: 100% !important;
}
  
.ql-editor li > .ql-ui:before {
  margin-left: -2.5em !important;
}

.ql-editor ol {
  padding-left: 0 !important;
}

/* Enhanced image styling for Gmail-like experience */
.ql-editor img {
  transition: all 0.2s ease-in-out !important;
  cursor: pointer !important;
  max-width: 100% !important;
  height: auto !important;
  border-radius: 4px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
}

.ql-editor img:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
  transform: translateY(-1px) !important;
}

.ql-editor img.ql-selected {
  border: 2px solid #4285f4 !important;
  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2) !important;
}

/* Image resize module styling */
.image-resize-display-size {
  position: absolute !important;
  background: rgba(0,0,0,0.8) !important; 
  color: white !important;
  font-size: 12px !important;
  padding: 4px 8px !important;
  border-radius: 4px !important;
  pointer-events: none !important;
  z-index: 1000 !important;
  font-family: Arial, sans-serif !important;
}

/* Custom resize handles */
.ql-image-resize {
  position: absolute !important;
  border: 1px dashed #4285f4 !important;
  background: transparent !important;
  z-index: 999 !important;
}

.ql-image-resize-handle {
  position: absolute !important;
  width: 8px !important;
  height: 8px !important;
  background: #4285f4 !important;
  border: 1px solid white !important;
  border-radius: 4px !important;
  cursor: nwse-resize !important;
  z-index: 1001 !important;
}

.ql-image-resize-handle:hover {
  background: #3367d6 !important;
  transform: scale(1.2) !important;
}

/* Handle positions */
.ql-image-resize-handle.nw { top: -4px; left: -4px; cursor: nw-resize; }
.ql-image-resize-handle.ne { top: -4px; right: -4px; cursor: ne-resize; }
.ql-image-resize-handle.sw { bottom: -4px; left: -4px; cursor: sw-resize; }
.ql-image-resize-handle.se { bottom: -4px; right: -4px; cursor: se-resize; }

/* Drag and drop indicator */
.ql-editor.ql-paste-image {
  border: 2px dashed #4285f4 !important;
  background-color: rgba(66, 133, 244, 0.05) !important;
  position: relative !important;
}

.ql-editor.ql-paste-image::after {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  color: #4285f4 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  pointer-events: none !important;
  background: white !important;
  padding: 8px 16px !important;
  border-radius: 4px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
}

.ql-editor {
  position: relative !important;
  padding: 12px 15px !important;
  line-height: 1.42 !important;
  height: 100% !important;
  overflow-y: auto !important;
}

/* Enhanced placeholder for image functionality */
.ql-editor.ql-blank::before {
  color: #9aa0a6 !important;
  font-style: italic !important;
  pointer-events: none !important;
  position: absolute !important;
  left: 15px !important;
  right: 15px !important;
  top: 12px !important;
  transition: opacity 0.2s ease !important;
}

.ql-editor.ql-blank:focus::before {
  opacity: 0 !important;
}

.ql-editor:not(.ql-blank)::before {
  display: none !important;
}

/* Ensure editor is properly focusable */
.ql-container.ql-snow {
  border: 1px solid #ccc !important;
  position: relative !important;
}

.ql-editor:focus {
  outline: none !important;
}

.ql-editor p:first-child {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.ql-editor > *:first-child {
  margin-top: 0 !important;
}

/* Loading state for images */
.ql-editor img[src="data:image/loading"] {
  opacity: 0.5 !important;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%) !important;
  background-size: 200% 100% !important;
  animation: loading 1.5s infinite !important;
}

@keyframes loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Error state for images */
.ql-editor img[src="data:image/error"] {
  border: 1px solid #ea4335 !important;
  background-color: #fef7f0 !important;
  opacity: 0.7 !important;
}

/* Image upload button enhancement */
.ql-toolbar .ql-image {
  position: relative !important;
}

.ql-toolbar .ql-image:hover {
  background-color: #f1f3f4 !important;
  border-radius: 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/RichTextEditor.css"],"names":[],"mappings":";AACA;EACE,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;EAC5C,wBAAwB;EACxB,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B,EAAE,sBAAsB;EAClD,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;EAChE,0BAA0B,EAAE,yCAAyC;EACrE,6BAA6B,EAAE,wCAAwC;AACzE;;AAEA;EACE,wBAAwB,EAAE,sCAAsC;EAChE,wBAAwB;EACxB,iCAAiC,EAAE,wCAAwC;AAC7E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qDAAqD;AACrD;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB,6BAA6B,SAAS,EAAE,UAAU,EAAE,iBAAiB,EAAE;AACvE,6BAA6B,SAAS,EAAE,WAAW,EAAE,iBAAiB,EAAE;AACxE,6BAA6B,YAAY,EAAE,UAAU,EAAE,iBAAiB,EAAE;AAC1E,6BAA6B,YAAY,EAAE,WAAW,EAAE,iBAAiB,EAAE;;AAE3E,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,oFAAoF;EACpF,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B","sourcesContent":["\n.ql-toolbar {\n  border-top-left-radius: 0.5rem !important;\n  border-top-right-radius: 0.5rem !important;\n}\n\n.ql-container {\n  border-bottom-left-radius: 0.5rem !important;\n  display: flex !important;\n  flex-direction: column !important;\n  border-bottom-right-radius: 0.5rem !important;\n}\n  \n.ql-blank, .ql-editor{\n  min-height: 8rem !important;\n  max-height: 30rem !important;\n  font-size: 14px !important; /* Default font size */\n  max-width: 100% !important;\n  white-space: normal !important;\n}\n\n.ql-editor span {\n  margin-left: 0 !important; /* Removes the unwanted left margin */\n  padding-left: 0 !important; /* Remove any padding that may be added */\n  font-size: inherit !important; /* Ensure font size remains consistent */\n}\n\n.react-quill {\n  height: 150px !important; /* Adjust height of the Quill editor */\n  padding: 10px !important;\n  box-sizing: border-box !important; /* Ensure padding doesn't affect width */\n}\n\n.ql-toolbar.ql-snow{\n  width: 100% !important;\n}\n\n.ql-container.ql-snow {\n  width: 100% !important;\n}\n  \n.ql-editor li > .ql-ui:before {\n  margin-left: -2.5em !important;\n}\n\n.ql-editor ol {\n  padding-left: 0 !important;\n}\n\n/* Enhanced image styling for Gmail-like experience */\n.ql-editor img {\n  transition: all 0.2s ease-in-out !important;\n  cursor: pointer !important;\n  max-width: 100% !important;\n  height: auto !important;\n  border-radius: 4px !important;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;\n}\n\n.ql-editor img:hover {\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;\n  transform: translateY(-1px) !important;\n}\n\n.ql-editor img.ql-selected {\n  border: 2px solid #4285f4 !important;\n  box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2) !important;\n}\n\n/* Image resize module styling */\n.image-resize-display-size {\n  position: absolute !important;\n  background: rgba(0,0,0,0.8) !important; \n  color: white !important;\n  font-size: 12px !important;\n  padding: 4px 8px !important;\n  border-radius: 4px !important;\n  pointer-events: none !important;\n  z-index: 1000 !important;\n  font-family: Arial, sans-serif !important;\n}\n\n/* Custom resize handles */\n.ql-image-resize {\n  position: absolute !important;\n  border: 1px dashed #4285f4 !important;\n  background: transparent !important;\n  z-index: 999 !important;\n}\n\n.ql-image-resize-handle {\n  position: absolute !important;\n  width: 8px !important;\n  height: 8px !important;\n  background: #4285f4 !important;\n  border: 1px solid white !important;\n  border-radius: 4px !important;\n  cursor: nwse-resize !important;\n  z-index: 1001 !important;\n}\n\n.ql-image-resize-handle:hover {\n  background: #3367d6 !important;\n  transform: scale(1.2) !important;\n}\n\n/* Handle positions */\n.ql-image-resize-handle.nw { top: -4px; left: -4px; cursor: nw-resize; }\n.ql-image-resize-handle.ne { top: -4px; right: -4px; cursor: ne-resize; }\n.ql-image-resize-handle.sw { bottom: -4px; left: -4px; cursor: sw-resize; }\n.ql-image-resize-handle.se { bottom: -4px; right: -4px; cursor: se-resize; }\n\n/* Drag and drop indicator */\n.ql-editor.ql-paste-image {\n  border: 2px dashed #4285f4 !important;\n  background-color: rgba(66, 133, 244, 0.05) !important;\n  position: relative !important;\n}\n\n.ql-editor.ql-paste-image::after {\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  color: #4285f4 !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  pointer-events: none !important;\n  background: white !important;\n  padding: 8px 16px !important;\n  border-radius: 4px !important;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;\n}\n\n.ql-editor {\n  position: relative !important;\n  padding: 12px 15px !important;\n  line-height: 1.42 !important;\n  height: 100% !important;\n  overflow-y: auto !important;\n}\n\n/* Enhanced placeholder for image functionality */\n.ql-editor.ql-blank::before {\n  color: #9aa0a6 !important;\n  font-style: italic !important;\n  pointer-events: none !important;\n  position: absolute !important;\n  left: 15px !important;\n  right: 15px !important;\n  top: 12px !important;\n  transition: opacity 0.2s ease !important;\n}\n\n.ql-editor.ql-blank:focus::before {\n  opacity: 0 !important;\n}\n\n.ql-editor:not(.ql-blank)::before {\n  display: none !important;\n}\n\n/* Ensure editor is properly focusable */\n.ql-container.ql-snow {\n  border: 1px solid #ccc !important;\n  position: relative !important;\n}\n\n.ql-editor:focus {\n  outline: none !important;\n}\n\n.ql-editor p:first-child {\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n}\n\n.ql-editor > *:first-child {\n  margin-top: 0 !important;\n}\n\n/* Loading state for images */\n.ql-editor img[src=\"data:image/loading\"] {\n  opacity: 0.5 !important;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%) !important;\n  background-size: 200% 100% !important;\n  animation: loading 1.5s infinite !important;\n}\n\n@keyframes loading {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* Error state for images */\n.ql-editor img[src=\"data:image/error\"] {\n  border: 1px solid #ea4335 !important;\n  background-color: #fef7f0 !important;\n  opacity: 0.7 !important;\n}\n\n/* Image upload button enhancement */\n.ql-toolbar .ql-image {\n  position: relative !important;\n}\n\n.ql-toolbar .ql-image:hover {\n  background-color: #f1f3f4 !important;\n  border-radius: 4px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
